import styled from '@benzinga/themetron';
import { ReactNode } from 'react';

import { DivComponent, toPxString } from './utils';

export interface BarProps {
  backgroundColor?: string;
  children?: ReactNode;
  height?: number;
}

/*
<BarChart>
  <Title>Title</Title>
  <Bar>
    <Fill color="#000000" end={1} start={0.5}>
      <Label flipped={start < threshold}>
    </Fill>
  </Bar>
</BarChart>
*/

export const Title = styled(DivComponent)`
  margin-bottom: ${() => toPxString(2)};
  position: relative;
  text-align: center;
`;

export const Bar = styled(DivComponent).attrs<
  BarProps & {
    backgroundColor?: string;
    height?: number;
  }
>(props => ({
  backgroundColor: props.backgroundColor || '#eee',
  height: props.height || 15,
}))<BarProps>`
  background-color: ${props => props.backgroundColor};
  height: ${props => toPxString(props.height as number)};
  position: relative;
  user-select: none;
`;

export const BarChart = styled(DivComponent)`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`;
